import { Col, Row, Collapse } from "antd";
import React, { useEffect } from "react";
import MenuItemLayout from "../menuItemLayout/MenuItemLayout";
import { CaretLeftOutlined } from "@ant-design/icons"; // Import the icon
import banner from "../../../assets/images/intern_banner.png";
import heroMobile from "../../../assets/images/intern-mob.png";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { getAllBranches } from "../../../apis/actions/branches.actions";
import { Branch } from "../../../interfaces/Branches.types";
import DotsLoader from "../../../biblio/Loader/DotsLoader";

const { Panel } = Collapse;



const OurBranches = () => {
  const dispatch = useDispatch<AppDispatch>();
  const branches = useSelector(
    (state: RootState) => state?.branches?.branches as Branch[]
  );

  useEffect(() => {
    dispatch(getAllBranches());
  }, [dispatch]);

  return (
    <MenuItemLayout
      mobileImage={heroMobile}
      title="من نحن"
      subTitle="الفروع"
      urlImage={banner}
      className="takaful--our-branches"
    >
      {branches?.length ? (
        <Row gutter={[16, 16]} justify="center">
          {branches.map((branch) => (
            <Col key={branch.id} xxl={20} xl={20} xs={22}>
              <Collapse
                bordered={false}
                defaultActiveKey={[]}
                className="takaful--branch-collapse"
              >
                <Panel
                  header={branch.name}
                  key={branch.id}
                  className="takaful--branch-panel"
                >
                  {branch.address === false ? (
                    branch.branch_office_ids.map((office, index) => (
                      <p>
                        <CaretLeftOutlined />
                        <a
                          href={office.google_map_location}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {office.name}
                        </a>
                      </p>
                    ))
                  ) : (
                    <p>
                      <CaretLeftOutlined />

                      <a
                        href={branch.google_map_location}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {branch.address}
                      </a>
                    </p>
                  )}
                </Panel>
              </Collapse>
            </Col>
          ))}
        </Row>
      ) : (
        <div className="takaful--loading-branches">
          <DotsLoader />

          <p className="takaful--no-project-message"> جارٍ التحميل</p>
        </div>
      )}
    </MenuItemLayout>
  );
};

export default OurBranches;
